<div class="central-dialog-backdrop" *ngIf="aberto" (click)="onFechar()"></div>

<section class="central-dialog" *ngIf="aberto" (click)="$event.stopPropagation()">
  <header class="central-dialog-header">
    <div>
      <h2>{{ etapaCadastroCliente ? 'Criar novo cliente' : (etapaEnderecos ? 'Escolher endereço do cliente' : 'Selecionar cliente da Central') }}</h2>
    </div>

    <button type="button" class="central-dialog-close" (click)="onFechar()" [disabled]="preparando || criandoCliente" aria-label="Fechar">
      <span>Esc</span>
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <line x1="18" y1="6" x2="6" y2="18"/>
        <line x1="6" y1="6" x2="18" y2="18"/>
      </svg>
    </button>
  </header>

  <div class="central-dialog-search" *ngIf="!etapaEnderecos && !etapaCadastroCliente">
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
      <circle cx="11" cy="11" r="8"/>
      <line x1="21" y1="21" x2="16.65" y2="16.65"/>
    </svg>
    <input
      #buscaCentralInput
      type="text"
      [ngModel]="termoBusca"
      (ngModelChange)="onTermoBuscaChange($event)"
      placeholder="Digite telefone ou nome do cliente"
      [disabled]="preparando"
      appAutoFocus>
    <button type="button" (click)="onBuscar()" [disabled]="!podeBuscar">
      {{ buscando ? 'Buscando...' : 'Buscar' }}
    </button>
  </div>

  <div class="central-dialog-error" *ngIf="erro">
    {{ erro }}
  </div>

  <div class="central-selected-client" *ngIf="etapaEnderecos">
    <span class="central-client-avatar is-selected">{{ getClientInitial(clienteSelecionado) }}</span>
    <div class="central-selected-client-main">
      <strong>{{ clienteSelecionado?.nome }}</strong>
      <small class="central-client-phone">
        <i class="fab fa-whatsapp" aria-hidden="true"></i>
        <span>{{ clienteSelecionado?.telefone | tel:(clienteSelecionado?.codigoPais || '+55') }}</span>
      </small>
    </div>
    <div class="central-selected-client-store">
      <span>Cliente da loja</span>
      <strong>{{ getLojaOrigem(clienteSelecionado) }}</strong>
    </div>
    <button type="button" class="central-change-client-btn" (click)="onTrocarCliente()" [disabled]="preparando">
      <span>F4</span>
      Trocar cliente
    </button>
  </div>

  <div class="central-dialog-body" [class.is-address-step]="etapaEnderecos">
    <main class="central-dialog-main">
      <ng-container *ngIf="etapaCadastroCliente; else fluxoCentralTpl">
        <form class="central-new-client-form" (ngSubmit)="onCriarCliente()">
          <div class="central-results-head">
            <strong>Cadastro rápido</strong>
            <span>Cliente novo</span>
          </div>

          <label class="central-field">
            <span>Nome</span>
            <input
              #novoClienteNomeInput
              type="text"
              name="centralNovoClienteNome"
              [(ngModel)]="novoCliente.nome"
              [disabled]="criandoCliente || preparando"
              autocomplete="off">
          </label>

          <label class="central-field">
            <span>Telefone</span>
            <input
              #novoClienteTelefoneInput
              type="tel"
              name="centralNovoClienteTelefone"
              [ngModel]="novoCliente.telefone"
              (ngModelChange)="onTelefoneNovoClienteChange($event)"
              inputmode="numeric"
              maxlength="15"
              placeholder="(00) 00000-0000"
              [disabled]="criandoCliente || preparando"
              autocomplete="off">
          </label>

          <div class="central-new-client-store" *ngIf="lojaCadastroAtual && !trocaLojaCadastroVisivel">
            <span>Loja do atendimento</span>
            <strong>{{ getLojaCadastroNome(lojaCadastroAtual) }}</strong>
            <button type="button"
                    class="central-new-client-store-change"
                    *ngIf="deveEscolherLojaCadastro"
                    (click)="onAlternarTrocaLojaCadastro()"
                    [disabled]="criandoCliente || preparando">
              Atender por outra loja
            </button>
          </div>

          <label class="central-field central-field-combo" *ngIf="deveEscolherLojaCadastro && trocaLojaCadastroVisivel">
            <span>Loja do atendimento</span>
            <kendo-combobox
              name="centralNovoClienteLoja"
              [data]="lojasCadastroComboItens"
              textField="nome"
              valueField="id"
              [valuePrimitive]="true"
              [filterable]="true"
              [suggest]="true"
              [allowCustom]="false"
              [kendoDropDownFilter]="comboFilterSettings"
              [(ngModel)]="novoCliente.empresaOrigemId"
              [disabled]="criandoCliente || preparando"
              placeholder="Selecione a loja do atendimento">
            </kendo-combobox>
          </label>

          <div class="central-form-actions">
            <button type="button" class="central-form-secondary" (click)="onVoltarParaBusca()" [disabled]="criandoCliente || preparando">
              Voltar para busca
            </button>
            <button type="submit" class="central-form-primary" [disabled]="!podeCriarCliente">
              {{ criandoCliente ? 'Criando...' : 'Criar cliente' }}
            </button>
          </div>
        </form>
      </ng-container>

      <ng-template #fluxoCentralTpl>
      <ng-container *ngIf="!etapaEnderecos; else enderecosTpl">
        <div class="central-results-head">
          <strong>Clientes encontrados</strong>
          <span *ngIf="totalClientes">{{ totalClientes }} resultado(s)</span>
        </div>

        <div class="central-shortcuts" *ngIf="totalClientes">
          <span><kbd>F4</kbd> busca</span>
          <span><kbd>↑</kbd><kbd>↓</kbd> navegar</span>
          <span><kbd>Enter</kbd> selecionar</span>
          <span><kbd>Alt</kbd> + <kbd>1</kbd>-<kbd>9</kbd> rápido</span>
        </div>

        <div class="central-create-inline" *ngIf="totalClientes">
          <span>Não é nenhum desses?</span>
          <button type="button" class="central-create-inline-btn" (click)="onAbrirCadastroCliente()" [disabled]="preparando || criandoCliente">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round">
              <line x1="12" y1="5" x2="12" y2="19"/>
              <line x1="5" y1="12" x2="19" y2="12"/>
            </svg>
            Cadastrar novo cliente
          </button>
        </div>

        <div class="central-empty-state" *ngIf="!buscando && !totalClientes && (!termoBusca || termoBusca.trim().length < 2)">
          <strong>Comece pela busca do cliente</strong>
          <span>Use telefone ou nome. Os resultados aparecem separados pela loja onde o cadastro foi encontrado.</span>
          <div class="central-empty-divider"><span>ou</span></div>
          <button type="button" class="central-empty-action is-ghost" (click)="onAbrirCadastroCliente()" [disabled]="preparando || criandoCliente">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round">
              <line x1="12" y1="5" x2="12" y2="19"/>
              <line x1="5" y1="12" x2="19" y2="12"/>
            </svg>
            Cadastrar novo cliente
          </button>
        </div>

        <div class="central-empty-state" *ngIf="buscando && !totalClientes">
          <strong>Buscando clientes...</strong>
          <span>Estamos consultando as lojas participantes da Central.</span>
        </div>

        <div class="central-empty-state is-compact" *ngIf="!buscando && buscaExecutada && termoBusca && termoBusca.trim().length >= 2 && !totalClientes">
          <span class="central-empty-icon" aria-hidden="true">+</span>
          <span class="central-empty-copy">
            <strong>Cliente não encontrado</strong>
            <small>Crie um cadastro rápido e continue o pedido na mesma tela.</small>
          </span>
          <button type="button" class="central-empty-continue" (click)="onAbrirCadastroCliente()" [disabled]="preparando || criandoCliente">
            Criar cliente
          </button>
        </div>

        <div class="central-client-groups" *ngIf="totalClientes">
          <div class="central-client-group" *ngFor="let grupo of clientesAgrupados; let grupoIndex = index; trackBy: trackByGrupo">
            <div class="central-client-group-title">
              {{ grupo.loja?.nome || 'Loja' }}
            </div>

            <button type="button"
                    #clienteCard
                    class="central-client-card"
                    *ngFor="let cliente of grupo.clientes; let clienteIndex = index; trackBy: trackByCliente"
                    [class.is-keyboard-selected]="isClienteAtivo(getClienteIndiceGlobal(grupoIndex, clienteIndex))"
                    (click)="onSelecionarClientePorClique(cliente, getClienteIndiceGlobal(grupoIndex, clienteIndex))">
              <span class="central-client-shortcut" *ngIf="getClienteAtalho(getClienteIndiceGlobal(grupoIndex, clienteIndex))">
                Alt+{{ getClienteAtalho(getClienteIndiceGlobal(grupoIndex, clienteIndex)) }}
              </span>
              <span class="central-client-avatar">{{ getClientInitial(cliente) }}</span>
              <span class="central-client-info">
                <strong>{{ cliente.nome }}</strong>
                <small class="central-client-phone">
                  <i class="fab fa-whatsapp" aria-hidden="true"></i>
                  <span>{{ cliente.telefone | tel:(cliente.codigoPais || '+55') }}</span>
                </small>
              </span>
              <span class="central-client-meta">
                {{ cliente.qtdePedidos || 0 }} pedido(s)
              </span>
            </button>
          </div>
        </div>
      </ng-container>
      </ng-template>

      <ng-template #enderecosTpl>
        <div class="central-results-head" *ngIf="enderecos?.length">
          <strong>Endereços cadastrados</strong>
          <span>{{ enderecos.length }} endereço(s)</span>
        </div>

        <div class="central-shortcuts" *ngIf="enderecos?.length">
          <span><kbd>↑</kbd><kbd>↓</kbd> navegar</span>
          <span><kbd>Enter</kbd> usar endereço</span>
          <span><kbd>Alt</kbd> + <kbd>1</kbd>-<kbd>9</kbd> rápido</span>
          <span><kbd>F4</kbd> trocar cliente</span>
        </div>

        <div class="central-create-inline" *ngIf="podeCriarNovoEndereco">
          <span>{{ enderecos?.length ? 'Endereço não está na lista?' : 'Cliente ainda não tem endereço.' }}</span>
          <button type="button"
                  class="central-create-inline-btn"
                  (click)="onCadastrarNovoEndereco()"
                  [disabled]="preparando">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round">
              <line x1="12" y1="5" x2="12" y2="19"/>
              <line x1="5" y1="12" x2="19" y2="12"/>
            </svg>
            Criar novo endereço
          </button>
        </div>

        <div class="central-empty-inline" *ngIf="!enderecos?.length && !podeCriarNovoEndereco && !lojaDestino">
          <span class="central-empty-inline-icon" aria-hidden="true">ℹ</span>
          <span>Sem endereço cadastrado — escolha retirada abaixo ou cadastre um endereço para delivery.</span>
        </div>

        <div class="central-create-inline" *ngIf="!enderecos?.length && lojaDestino && lojaDestinoPermiteRetiradaDireto">
          <span>Cliente vai retirar na loja?</span>
          <button type="button"
                  class="central-create-inline-btn is-primary"
                  (click)="onContinuarRetiradaDestino()"
                  [disabled]="preparando">
            {{ preparando ? 'Preparando...' : 'Continuar com retirada' }}
          </button>
        </div>

        <ng-container *ngIf="!enderecos?.length && !lojaDestino">
          <div class="central-section-head" *ngIf="lojasRetirada.length">
            <strong>Pegar agora · retirada</strong>
            <span>{{ lojasRetirada.length }} loja(s)</span>
          </div>

          <div class="central-no-address-stores" *ngIf="lojasRetirada.length">
            <button type="button"
                    class="central-no-address-store"
                    *ngFor="let loja of lojasRetirada; trackBy: trackByLoja"
                    [class.is-pickup]="true"
                    [class.is-cliente-origem]="isLojaOrigemCliente(loja)"
                    [class.is-selected]="isLojaSemEnderecoSelecionada(loja)"
                    [disabled]="preparando"
                    (click)="onSelecionarLojaSemEndereco(loja)">
              <span class="central-no-address-check" *ngIf="isLojaSemEnderecoSelecionada(loja)" aria-hidden="true">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3">
                  <polyline points="20 6 9 17 4 12"/>
                </svg>
              </span>
              <span class="central-no-address-store-icon">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M4 10h16l-2-6H6l-2 6Z"/>
                  <path d="M6 10v10h12V10"/>
                  <path d="M10 20v-6h4v6"/>
                  <path d="M4 10c0 2 1.5 3 3 3s3-1 3-3c0 2 1.5 3 3 3s3-1 3-3c0 2 1.5 3 3 3s3-1 3-3"/>
                </svg>
              </span>
              <span class="central-no-address-store-copy">
                <strong class="central-loja-nome">
                  <ng-container *ngIf="getNomePartes(loja) as partes">
                    <span class="central-loja-nome-comum" *ngIf="partes.prefixo">{{ partes.prefixo }}</span><span class="central-loja-nome-distintivo">{{ partes.destaque }}</span><span class="central-loja-nome-comum" *ngIf="partes.sufixo">{{ partes.sufixo }}</span>
                  </ng-container>
                  <span class="central-loja-badge-origem" *ngIf="isLojaOrigemCliente(loja)">Loja do cliente</span>
                </strong>
                <small *ngIf="!isLojaOrigemCliente(loja)">Loja participante</small>
              </span>
              <span class="central-no-address-store-action"
                    [class.is-primary]="isLojaSemEnderecoSelecionada(loja)">
                {{ isLojaSemEnderecoSelecionada(loja) && preparando ? 'Preparando...' : (isLojaSemEnderecoSelecionada(loja) ? 'Continuar' : 'Retirar aqui') }}
              </span>
            </button>
          </div>

          <div class="central-section-head" *ngIf="lojasDeliveryRequerEndereco.length" [class.has-margin-top]="lojasRetirada.length">
            <strong>Entregar · precisa de endereço</strong>
            <span>{{ lojasDeliveryRequerEndereco.length }} loja(s)</span>
          </div>

          <div class="central-no-address-stores" *ngIf="lojasDeliveryRequerEndereco.length">
            <button type="button"
                    class="central-no-address-store requires-address"
                    *ngFor="let loja of lojasDeliveryRequerEndereco; trackBy: trackByLoja"
                    [class.is-cliente-origem]="isLojaOrigemCliente(loja)"
                    [disabled]="preparando"
                    (click)="onSelecionarLojaSemEndereco(loja)">
              <span class="central-no-address-store-icon is-warn">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 1 1 18 0z"/>
                  <circle cx="12" cy="10" r="3"/>
                </svg>
              </span>
              <span class="central-no-address-store-copy">
                <strong class="central-loja-nome">
                  <ng-container *ngIf="getNomePartes(loja) as partes">
                    <span class="central-loja-nome-comum" *ngIf="partes.prefixo">{{ partes.prefixo }}</span><span class="central-loja-nome-distintivo">{{ partes.destaque }}</span><span class="central-loja-nome-comum" *ngIf="partes.sufixo">{{ partes.sufixo }}</span>
                  </ng-container>
                  <span class="central-loja-badge-origem" *ngIf="isLojaOrigemCliente(loja)">Loja do cliente</span>
                </strong>
                <small *ngIf="!isLojaOrigemCliente(loja)">Loja participante</small>
              </span>
              <span class="central-no-address-store-action requires-address">
                Cadastrar endereço
              </span>
            </button>
          </div>
        </ng-container>

        <div class="central-address-list" *ngIf="enderecos?.length">
          <button type="button"
                  #enderecoCard
                  class="central-address-card"
                  *ngFor="let endereco of enderecos; let i = index; trackBy: trackByEndereco"
                  [class.is-suggested]="i === 0 && !enderecoSelecionado"
                  [class.is-keyboard-selected]="isEnderecoAtivo(i)"
                  [class.is-selected]="(enderecoSelecionado?.enderecoId || enderecoSelecionado?.id) === (endereco?.enderecoId || endereco?.id)"
                  (click)="onSelecionarEnderecoPorClique(endereco, i)"
                  [disabled]="preparando">
            <span class="central-address-shortcut" *ngIf="getEnderecoAtalho(i)">
              Alt+{{ getEnderecoAtalho(i) }}
            </span>
            <span class="central-address-pin" [class.is-blue]="i % 3 === 1" [class.is-purple]="i % 3 === 2">
              <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 1 1 18 0z"/>
                <circle cx="12" cy="10" r="3"/>
              </svg>
            </span>
            <span class="central-address-info">
              <strong>{{ getEnderecoPrincipal(endereco) }}</strong>
              <small>{{ getEnderecoSecundario(endereco) }}</small>
            </span>
            <span class="central-address-tag"
                  *ngIf="getEnderecoTipoLabel(endereco)"
                  [ngClass]="getEnderecoTipoClasse(endereco)">
              {{ getEnderecoTipoLabel(endereco) }}
            </span>
            <span class="central-address-action">
              {{ preparando ? 'Aguarde' : 'Usar este endereço' }}
            </span>
            <span class="central-address-chevron" aria-hidden="true">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="9 18 15 12 9 6"/>
              </svg>
            </span>
          </button>
        </div>

        <div class="central-results-head central-pickup-head" *ngIf="enderecos?.length && lojasRetirada.length">
          <strong>Retirada na loja</strong>
          <span>{{ lojasRetirada.length }} loja(s)</span>
        </div>

        <div class="central-no-address-stores" *ngIf="enderecos?.length && lojasRetirada.length">
          <button type="button"
                  class="central-no-address-store is-pickup"
                  *ngFor="let loja of lojasRetirada; trackBy: trackByLoja"
                  [class.is-selected]="isLojaSemEnderecoSelecionada(loja)"
                  [disabled]="preparando"
                  (click)="onSelecionarLojaSemEndereco(loja)">
            <span class="central-no-address-check" *ngIf="isLojaSemEnderecoSelecionada(loja)" aria-hidden="true">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3">
                <polyline points="20 6 9 17 4 12"/>
              </svg>
            </span>
            <span class="central-no-address-store-icon">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M4 10h16l-2-6H6l-2 6Z"/>
                <path d="M6 10v10h12V10"/>
                <path d="M10 20v-6h4v6"/>
                <path d="M4 10c0 2 1.5 3 3 3s3-1 3-3c0 2 1.5 3 3 3s3-1 3-3c0 2 1.5 3 3 3s3-1 3-3"/>
              </svg>
            </span>
            <span class="central-no-address-store-copy">
              <strong class="central-loja-nome">
                <ng-container *ngIf="getNomePartes(loja) as partes">
                  <span class="central-loja-nome-comum" *ngIf="partes.prefixo">{{ partes.prefixo }}</span><span class="central-loja-nome-distintivo">{{ partes.destaque }}</span><span class="central-loja-nome-comum" *ngIf="partes.sufixo">{{ partes.sufixo }}</span>
                </ng-container>
              </strong>
              <small>{{ getLojaSemEnderecoSubtitulo(loja) }}</small>
            </span>
            <span class="central-no-address-store-status">
              <i></i>
              Retirada disponível
            </span>
            <span class="central-no-address-store-action"
                  [class.is-primary]="isLojaSemEnderecoSelecionada(loja)">
              {{ getLojaSemEnderecoAcao(loja) }}
            </span>
          </button>
        </div>
      </ng-template>
    </main>

    <aside class="central-dialog-aside">
      <ng-container *ngIf="!etapaEnderecos">
        <div class="central-step-card"
             [class.is-active]="etapaCadastroCliente"
             [class.is-done]="clienteSelecionado">
        <span class="central-step-index">1</span>
        <div>
          <strong>Cliente</strong>
          <small>{{ getResumoEtapaCliente() }}</small>
        </div>
      </div>

      <div class="central-new-client-preview" *ngIf="etapaCadastroCliente && (novoCliente?.nome || novoCliente?.telefone)">
        <span class="central-client-avatar">{{ getNovoClienteInitial() }}</span>
        <div class="central-new-client-preview-info">
          <strong>{{ novoCliente?.nome || 'Novo cliente' }}</strong>
          <small class="central-client-phone" *ngIf="novoCliente?.telefone">
            <i class="fab fa-whatsapp" aria-hidden="true"></i>
            <span>{{ novoCliente.telefone }}</span>
          </small>
          <small *ngIf="lojaCadastroAtual" class="central-new-client-preview-store">
            Atendimento: {{ getLojaCadastroNome(lojaCadastroAtual) }}
          </small>
        </div>
      </div>

      <div class="central-step-card" [class.is-done]="enderecoSelecionado" [class.is-active]="clienteSelecionado && !enderecoSelecionado">
        <span class="central-step-index">2</span>
        <div>
          <strong>Endereço</strong>
          <small>{{ enderecoSelecionado ? getEnderecoPrincipal(enderecoSelecionado) : 'Escolha o endereço de delivery' }}</small>
        </div>
      </div>
      </ng-container>

      <div class="central-destination-card" [class.is-ready]="lojaDestinoVisual">
        <span>Loja destino</span>
        <div class="central-destination-store-name" *ngIf="lojaDestinoVisual">
          <span class="central-destination-mini-store" aria-hidden="true">
            <svg width="23" height="23" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M4 10h16l-2-6H6l-2 6Z"/>
              <path d="M6 10v10h12V10"/>
              <path d="M10 20v-6h4v6"/>
            </svg>
          </span>
          <strong>{{ lojaDestinoVisual.nome }}</strong>
        </div>
        <div class="central-destination-visual" *ngIf="!lojaDestinoVisual">
          <span class="central-destination-store">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9">
              <path d="M3 9l1.2-5h15.6L21 9"/>
              <path d="M5 9v10h14V9"/>
              <path d="M9 19v-6h6v6"/>
              <path d="M3 9h18"/>
            </svg>
          </span>
          <svg class="central-destination-route" width="76" height="44" viewBox="0 0 76 44" fill="none">
            <path d="M6 10c18 0 8 24 28 24 18 0 13-21 35-21" stroke="#9aa9c0" stroke-width="3" stroke-linecap="round" stroke-dasharray="3 9"/>
          </svg>
          <span class="central-destination-pin">
            <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 1 1 18 0z"/>
              <circle cx="12" cy="10" r="3"/>
            </svg>
          </span>
        </div>
        <strong *ngIf="!lojaDestinoVisual && !preparando">Aguardando endereço</strong>
        <strong *ngIf="preparando && !lojaDestinoVisual">Resolvendo loja...</strong>
        <small *ngIf="!lojaDestinoVisual">A loja será definida automaticamente pelo bairro.</small>
      </div>

      <div class="central-dialog-hint" *ngIf="!etapaEnderecos">
        <strong>Depois da loja resolvida</strong>
        <span>O cardápio, carrinho e pagamento passam a usar a unidade destino.</span>
      </div>
    </aside>
  </div>
</section>
